export const TYPOGRAPHY_REQUIRED_PROPERTIES = [
  'fontFamily',
  'fontSize',
  'fontWeight',
  'letterSpacing',
  'lineHeight',
] as const;
